module.exports = __webpack_public_path__ + "static/media/Bayer_Logo.4c58a598.png";